import React from 'react'
import get from 'lodash.get'
import moment from 'moment'
import GatsbyConfig from '../../../gatsby-config.js'
import { formatPrice } from '../../utils/app-helpers'

const { siteMetadata: config } = GatsbyConfig

export default class AddNightsSummary extends React.Component {
  render() {
    const { trip, perNight, paid } = this.props
    const tripData = config.trips[trip]
    const nightsBefore = parseInt(get(this, 'props.nightsBefore', 0), 10)
    const nightsAfter = parseInt(get(this, 'props.nightsAfter', 0), 10)
    const checkInDate = moment(tripData.checkInDate, 'MMM D, YYYY').subtract(
      'day',
      nightsBefore
    )
    const checkOutDate = moment(tripData.checkOutDate, 'MMM D, YYYY').add(
      'day',
      nightsAfter
    )

    if (!nightsBefore && !nightsAfter) return <div />
    return (
      <div className="summary">
        {nightsBefore ? (
          <dl>
            <dt>
              {nightsBefore} Extra Night{nightsBefore === 1 ? ' ' : 's '}
              Before ({formatPrice(perNight)} per night)
            </dt>
            <dd>{formatPrice(nightsBefore * perNight)}</dd>
          </dl>
        ) : (
          ''
        )}
        {nightsAfter ? (
          <dl>
            <dt>
              {nightsAfter} Extra Night{nightsAfter === 1 ? ' ' : 's '}
              After ({formatPrice(perNight)} per night)
            </dt>
            <dd>{formatPrice(nightsAfter * perNight)}</dd>
          </dl>
        ) : (
          ''
        )}
        <dl className="total">
          <dt>{paid ? 'Additional Total Paid' : 'Total'}</dt>
          <dd>{formatPrice((nightsBefore + nightsAfter) * perNight)}</dd>
        </dl>
        <p>* Price includes all taxes & fees</p>
        {nightsBefore ? (
          <p>
            * Your new check-in date
            {paid ? ' is ' : ' will be '}
            {checkInDate.format('MMM D, YYYY')}
          </p>
        ) : (
          ''
        )}
        {nightsAfter ? (
          <p>
            * Your new check-out date
            {paid ? ' is ' : ' will be '}
            {checkOutDate.format('MMM D, YYYY')}
          </p>
        ) : (
          ''
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/add-nights-summary.js